import { ScenarioCaseBase } from './base/scenario-case-base';

export class ScenarioCase extends ScenarioCaseBase { }